import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import { Loader } from './Loader';
import { InlineError } from './Error';
import { NoResult } from './NoResult';

import Clear from './Clear';
import Checkbox from './forms/Checkbox';

import partIdQueryHelper from '../utils/partIdQueryHelper';
import { withAppStorage } from '../utils/appStorage';

const StyledPartGroupsWithTypesCheckboxList = styled.div`
  margin: 0;
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const SubList = styled(List)`
  margin: 5px 0 5px 15px;
`;

const ListItem = styled.li`
  margin: 0;
`;

const GET_VARIANTS = gql`
  query getPartTypes($partGroupId: Int!) {
    types: getPartTypes(GruppId: $partGroupId) {
      items {
        value: Delkod
        label: DelkodNamnNorge
      }
    }
  }
`;

function PartGroupsWithTypesCheckboxList({
  groups,
  location,
  history,
  appStorageTempData,
  appStorage
}) {
  const query = qs.parse(location.search, { arrayFormat: 'bracket' });

  let partGroupIds = query.delegrupper || [];
  if (partGroupIds) partGroupIds = partGroupIds.map(Number); // Convert values to Int.

  let partTypesIds = query.deletyper || [];
  if (partTypesIds) partTypesIds = partTypesIds.map(Number); // Convert values to Int.

  const sortAscByLabel = (a, b) => {
    return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
  };

  const handleClear = () => {
    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          delegrupper: undefined,
          deletyper: undefined
        },
        {
          arrayFormat: 'bracket'
        }
      )
    });
  };

  const handlePartGroupsChange = (selectedItem, childPartTypes) => {
    const currentPartGroupItemIds = [...partGroupIds];
    const currentPartTypeIds = [...partTypesIds];

    const idx = currentPartGroupItemIds.indexOf(selectedItem.value);
    if (idx >= 0) currentPartGroupItemIds.splice(idx, 1);
    else currentPartGroupItemIds.push(selectedItem.value);

    if (childPartTypes) {
      childPartTypes.forEach(id => {
        let index = currentPartTypeIds.indexOf(id);

        if (index >= 0) currentPartTypeIds.splice(index, 1);
      });
    }

    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          delegrupper: currentPartGroupItemIds,
          deletyper: currentPartTypeIds
        },
        {
          arrayFormat: 'bracket'
        }
      )
    });
  };

  const handlePartTypesChange = selectedItem => {
    const currentItemIds = [...partTypesIds];

    const idx = currentItemIds.indexOf(selectedItem.value);
    if (idx >= 0) currentItemIds.splice(idx, 1);
    else currentItemIds.push(selectedItem.value);

    history.push({
      pathname: '/bildeler/',
      search: qs.stringify(
        {
          ...query,
          deletyper: currentItemIds
        },
        {
          arrayFormat: 'bracket'
        }
      )
    });
  };

  const renderCheckboxList = groups.sort(sortAscByLabel).map(group => {
    const checked = partGroupIds.includes(group.value);

    return (
      <ListItem key={group.value}>
        <Checkbox
          name="partGroups"
          label={group.label}
          value={group.value}
          checked={checked}
          onChange={(e) => {
            let childInputs = e.target.parentElement.parentElement.querySelectorAll('input');
            let childInputIds = [];

            for (let i = 0; i < childInputs.length; i++) {
              if (childInputs[i].checked) {
                childInputIds.push(parseInt(childInputs[i].value));
              }
            }

            handlePartGroupsChange(group, childInputIds);
          }/* TODO: On click, check if child is also chose in so remove */}
        />

        {checked && (
          <SubList>
            <Query
              query={GET_VARIANTS}
              variables={{
                partGroupId: group.value
              }}
              onCompleted={({ types }) => {
                if (!types || !types.items) {
                  return;
                }

                partIdQueryHelper.addPartItems(types.items, group.value);

                if (
                  appStorageTempData.partGroupsLoaded.indexOf(group.value) > -1
                ) {
                  return;
                }

                appStorageTempData.partGroupsLoaded.push(group.value);
                appStorage.setTempData(
                  'partGroupsLoaded',
                  appStorageTempData.partGroupsLoaded
                );
              }}
            >
              {({ loading, error, data }) => {
                if (loading) {
                  return <Loader />;
                }

                if (error) {
                  return <InlineError error={error} />;
                }

                if (!data.types.items) {
                  return <NoResult msg="Ingen deletyper ble funnet!" />;
                }

                return data.types.items.sort(sortAscByLabel).map(type => (
                  <ListItem key={type.value}>
                    <Checkbox
                      name="partTypes"
                      value={type.value}
                      label={type.label}
                      checked={partTypesIds.includes(type.value)}
                      onChange={() => handlePartTypesChange(type)}
                    />
                  </ListItem>
                ));
              }}
            </Query>
          </SubList>
        )}
      </ListItem>
    );
  });

  return (
    <StyledPartGroupsWithTypesCheckboxList>
      <Clear onClearClick={handleClear} />

      <List>{renderCheckboxList}</List>
    </StyledPartGroupsWithTypesCheckboxList>
  );
}

PartGroupsWithTypesCheckboxList.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default withAppStorage(withRouter(PartGroupsWithTypesCheckboxList));
